module.exports = __webpack_public_path__ + "img/logo_IC_positivo.43f22add.png";